/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useState} from 'react'
//import Swal from 'sweetalert2'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl, defaultAlerts} from '../../../helpers'
import {useIntl} from 'react-intl'
import axios from 'axios'

const moment = require('moment')
const API_URL = process.env.REACT_APP_API_URL || 'api'
interface LogModel {
  id: number
  event: string
  state: 'success'
  log_name: string
  causer_id: string
  created_at: Date
  properties: {
    attributes: Array<any>
  }
}

const HeaderNotificationsMenu: FC = () => {
  const intl = useIntl()
  const [logs, setLogs] = useState([])
  const [cont, setCont] = useState(0)

  let defaultLogs: Array<LogModel> = logs

  //BUSCA TOKEN NO LOCALSTORAGE
  let token = localStorage.getItem('auth_storage')
  if (token) token = token.replace(/['"]+/g, '')
  let config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }

  //funcao para buscar os logs
  // fazer filtro para buscar somente os logs do usuario logado
  async function getLogs() {
    let logs = await axios
      .get(API_URL + '/v1/activity_logs', config)
      .then()
      .catch()
    if (cont <= 1) {
      setLogs(logs.data.data.reverse())
      setCont(cont + 1)
    }
    // setLogs(logs.data.data)
  }

  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
        data-kt-menu='true'
      >
        {/* imagem de fundo da notificação */}
        <div
          className='d-flex flex-column bgi-no-repeat rounded-top border border-1 borde border-bottom-0 border-gray-100'
          style={{
            backgroundImage: `url('${toAbsoluteUrl('/media/misc/fundoNoti.jpg')}')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'repeat',
          }}
        >
          <h2
            className='text-white fw-bold px-9 mt-10 mb-6 bg-verde-claro bg-opacity-50 rounded-top'
            style={{textShadow: '3px 3px 3px black'}}
          >
            {intl.formatMessage({id: 'NOTIFICATION.TITLE'})}
          </h2>

          <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
            <li className='nav-item'>
              <a
                className='nav-link text-white opacity-100 opacity-state-75 pb-4 '
                style={{textShadow: '2px 2px 2px black'}}
                data-bs-toggle='tab'
                href='#kt_topbar_notifications_1'
              >
                {intl.formatMessage({id: 'COMMON.ALERTS'})}
              </a>
            </li>

            <li className='nav-item'>
              <a
                className='nav-link text-white  opacity-100 opacity-state-75 pb-4 active '
                style={{textShadow: '2px 2px 2px black'}}
                data-bs-toggle='tab'
                href='#kt_topbar_notifications_2'
              >
                {intl.formatMessage({id: 'COMMON.UPDATES'})}
              </a>
            </li>

            <li className='nav-item'>
              <a
                className='nav-link text-white  opacity-100 opacity-state-75 pb-4'
                style={{textShadow: '2px 2px 2px black'}}
                data-bs-toggle='tab'
                href='#kt_topbar_notifications_3'
                onClick={getLogs}
              >
                Logs
              </a>
            </li>
          </ul>
        </div>

        <div className='tab-content'>
          <div className='tab-pane fade' id='kt_topbar_notifications_1' role='tabpanel'>
            <div className='scroll-y mh-325px my-5 px-8'>
              {defaultAlerts.map((alert, index) => (
                <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-35px me-4'>
                      <span className={clsx('symbol-label', `bg-light-${alert.state}`)}>
                        {' '}
                        <KTSVG
                          path={`/media/${alert.icon}`}
                          className={`svg-icon-2 svg-icon-${alert.state}`}
                        />
                      </span>
                    </div>

                    <div className='mb-0 me-2'>
                      <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                        {alert.title}
                      </a>
                      <div className='text-gray-400 fs-7'>{alert.description}</div>
                    </div>
                  </div>

                  <span className='badge badge-light fs-8'>{alert.time}</span>
                </div>
              ))}
            </div>

            <div className='py-3 text-center border-top'>
              <Link
                to='/crafted/pages/profile'
                className='btn btn-color-gray-600 btn-active-color-primary'
              >
                {intl.formatMessage({id: 'COMMON.VIEWALL'})}{' '}
                <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
              </Link>
            </div>
          </div>

          <div
            className='tab-pane fade show active '
            id='kt_topbar_notifications_2'
            role='tabpanel'
          >
            <div className='d-flex flex-column px-9'>
              <div className='pt-10 pb-0'>
                <h3 className='text-dark text-center fw-bolder'>Nova Atualização do Sistema </h3>

                <div className='text-center text-gray-600 fw-bold pt-1'>
                  O sistema foi atualizado recentemente, verifique as novas funcionalidades
                </div>
                <div
                  style={{
                    backgroundImage: `url('${toAbsoluteUrl('/media/logos/globo.gif')}')`,
                  }}
                ></div>

                <div className='text-center mt-5 mb-9'>
                  {/* <a
                    href='#'
                    className='btn btn-sm btn-primary px-6'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_upgrade_plan'
                  >
                    Visualizar
                  </a> */}
                </div>
              </div>

              <div className='text-center px-4'>
                <img
                  className='mw-100 mh-200px'
                  alt='Orbit'
                  src={toAbsoluteUrl('/media/logos/globo.gif')}
                />
              </div>
            </div>
          </div>

          <div className='tab-pane fade' id='kt_topbar_notifications_3' role='tabpanel'>
            <div className='scroll-y mh-325px my-5 px-8'>
              {/* {defaultLogs.length === 0 && intl.formatMessage({id: 'AUTH.PLEASEWAIT'})} */}
              {defaultLogs.length === 0 && (
                <img
                  className='mw-100 mh-200'
                  alt='Orbit'
                  src={toAbsoluteUrl('/media/logos/loading1.gif')}
                />
              )}
              {defaultLogs.length > 0 &&
                defaultLogs.map((log, index) => (
                  <div key={`log${index}`} className='d-flex flex-stack py-4'>
                    <div className='d-flex align-items-center me-2'>
                      <span className={clsx('w-120px badge', `badge-light-success`, 'me-4')}>
                        <a
                          onClick={() => {
                            let mystring = JSON.stringify(log.properties.attributes).replace(
                              /,/g,
                              '\n'
                            )
                            mystring = mystring.replace(/{/g, ' ')
                            mystring = mystring.replace(/"/g, ' ')
                            mystring = mystring.replace(/}/g, ' ')
                            alert(mystring)
                          }}
                        >
                          {log.event} {log.log_name}
                        </a>
                      </span>

                      <a href='#' className='text-gray-800 text-hover-primary fw-bold'>
                        {/* {log.causer_id} */}
                      </a>
                      <span className='badge badge-light fs-8'>
                        {moment(log.created_at).format('HH:mm:ss - DD/MM/yyyy')}
                      </span>
                    </div>
                  </div>
                ))}
            </div>

            <div className='py-3 text-center border-top'>
              <Link to='/historylogs' className='btn btn-color-gray-600 btn-active-color-primary '>
                {intl.formatMessage({id: 'COMMON.VIEWALL'})}{' '}
                <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {HeaderNotificationsMenu}
